import { render } from "./MiraLoader.vue?vue&type=template&id=0eff91e0"
import script from "./MiraLoader.vue?vue&type=script&lang=js"
export * from "./MiraLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__